import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFontFamily = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polyline", { points: "4 7 4 4 20 4 20 7" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			y1: 20,
			x2: 15,
			y2: 20
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 4,
			x2: 12,
			y2: 20
		})
	]
});
export default SvgFontFamily;
